import { Skeleton } from "@aviary";

import { TrayColumnItem, TrayColumns } from "../TrayColumns";

import * as styles from "./SkeletonColumnList.styles";

const renderSkeletonListItems = numberOfColumns => {
  return Array.from({ length: numberOfColumns }).map((element, index) => (
    <TrayColumnItem
      css={styles.trayColumnItemSkeleton}
      key={`"brandslistskeleton${index}${element}`}
    >
      <Skeleton css={styles.skeletonButton} type="button" buttonSize="xsmall" isFullwidth />
      <Skeleton css={styles.skeletonButton} type="button" buttonSize="xsmall" isFullwidth />
      <Skeleton css={styles.skeletonButton} type="button" buttonSize="xsmall" isFullwidth />
      <Skeleton css={styles.skeletonButton} type="button" buttonSize="xsmall" isFullwidth />
      <Skeleton css={styles.skeletonButton} type="button" buttonSize="xsmall" isFullwidth />
    </TrayColumnItem>
  ));
};
interface Props {
  numberOfColumns: number;
}

const SkeletonColumnList = ({ numberOfColumns, ...rest }: Props) => (
  <TrayColumns columnCount={numberOfColumns} {...rest}>
    {renderSkeletonListItems(numberOfColumns)}
  </TrayColumns>
);

export { SkeletonColumnList };
